<template>
  <div id="layoutSidenav_nav">
    <nav class="sb-sidenav accordion sb-sidenav-light" id="sidenavAccordion" style="  border-top: #FFFFFF;">
      <div class="sb-sidenav-menu">
        <div class="nav">
          <div class="sb-sidenav-menu-heading">Core</div>

          <!-- comment out as of 03/01/2022         -->
          <!--<router-link href="#" class="nav-link"  :to="{name:'Dashboard'}" :class="{ 'active': isRouteActive('Dashboard')}">
            <div class="sb-nav-link-icon">
              <font-awesome-icon icon="tachometer-alt"/>
            </div>
            Dashboard
          </router-link>-->

          <div class="sb-sidenav-menu-heading">Modules</div>

          <router-link v-if="!isCrew" href="#" class="nav-link" :to="{name : 'CrewTONS'}" :class="{ 'active': isRouteActive('CrewTONS')}">
            <div class="sb-nav-link-icon">
              <font-awesome-icon icon="clipboard"/>
            </div>
            Turnover Notes
          </router-link>

          <router-link v-if="isCrew" href="#" class="nav-link" :to="{name : 'CrewViewTon'}" :class="{ 'active': isRouteActive('CrewViewTon')}">
            <div class="sb-nav-link-icon">
              <font-awesome-icon icon="clipboard"/>
            </div>
            Turnover Notes
          </router-link>

          <a v-if="isSystemAdmin" class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseSettings" aria-expanded="false" aria-controls="collapseSettings"
             :class="{ 'active': isRouteActive('Settings')}">
            <div class="sb-nav-link-icon">
              <font-awesome-icon icon="cogs"/>
            </div>
            Settings
            <div class="sb-sidenav-collapse-arrow">
              <font-awesome-icon  icon="angle-down"/>
            </div>
          </a>

          <div class="collapse" id="collapseSettings" aria-labelledby="headingOne" data-parent="#collapseSettings">
            <nav class="sb-sidenav-menu-nested nav">
              <router-link :to="{name : 'Vessels'}" class="nav-link" :class="{ 'active': isRouteActive('Vessels'), 'active': isVessel()}">
                Vessels
              </router-link>

              <router-link :to="{name : 'SIAccounts'}" class="nav-link" :class="{ 'active': isRouteActive('SIAccounts')}">
                S.I Accounts
              </router-link>

              <!-- <router-link :to="{name : 'CMSAccounts'}" class="nav-link" href="#" :class="{ 'active': isRouteActive('CMSAccounts')}">
                CMS Accounts
              </router-link> -->
            </nav>
          </div>
        </div>
      </div>

      <div class="sb-sidenav-footer">
        <div class="small">Logged in as:</div>
        {{ authPos.shortName.toUpperCase() }}
      </div>
    </nav>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {AppMixins} from '../../../../mixins/app.mixins';
import {PosMixins} from '../../../../mixins/pos.mixins';

export default {
  name: 'Nav',

  /** mixins **/
  mixins: [AppMixins,PosMixins],

  /** props **/
  props: {
    position: {
      type: String,
      default: 'System Admin',
    },
  },

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {
    configSideNav() {
      // Add active state to sidbar nav links
      let path = window.location.href; // because the 'href' property of the DOM element is the absolute path
      $('#layoutSidenav_nav .sb-sidenav a.nav-link').each(function() {
        if (this.href === path) {
          $(this).addClass('active');
        }
      });

      // Toggle the side navigation
      $('#sidebarToggle').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('sb-sidenav-toggled');
      });
    },
  },

  /**  computed  **/
  computed: {
    ...mapGetters([
        // 'authPos'
    ])
  },

  /** mounted **/
  mounted() {
    this.$nextTick(() => {
      this.configSideNav();
    });
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped>

</style>
